import {
  OrderOrigin,
  OrderPaymentStatus,
  OrderReceiptStatus,
} from '@/interfaces/billing'

import { DocumentType } from '../../billingPortals/newRegisterWizard/NewRegisterWizard'

// Map OrderReceiptStatus to Spanish labels
export const ORDER_STATUS_LABELS: Record<OrderReceiptStatus, string> = {
  CREATED: 'Creada',
  IN_PROCESS: 'En proceso',
  PROCESSED: 'Procesada',
  COMPLETED: 'Completada',
  CANCELLED: 'Cancelada',
  DELIVERY_ASSIGNED: 'Asignada a mensajero',
  ACCEPTED: 'Aceptada por mensajero',
  IN_TRANSIT: 'En tránsito',
  DELIVERED: 'Entregada',
  REFUNDED: 'Reembolsada',
}

// Map OrderPaymentStatus to Spanish labels
export const PAYMENT_STATUS_LABELS: Record<OrderPaymentStatus, string> = {
  PAYMENT_PENDING: 'Pendiente de pago',
  BILLED: 'Pagada',
  REFUNDED: 'Reembolsada',
  PARTIALLY_REFUNDED: 'Parcialmente reembolsada',
  CANCELLED: 'Cancelada',
  PARTIALLY_PAID: 'Parcialmente pagada',
}

export const dateTypeOptions = [
  { value: 'emision', label: 'Fecha de emisión' },
  { value: 'vencimiento', label: 'Fecha de vencimiento' },
  { value: 'entrega', label: 'Fecha de entrega' },
  { value: 'facturacion', label: 'Fecha de facturación' },
] as const

export const codeCurrencyOptions = [
  { value: 'USD', label: 'USD' },
  { value: 'CUP', label: 'CUP' },
  { value: 'EUR', label: 'EUR' },
  { value: 'MLC', label: 'MLC' },
  { value: 'MXN', label: 'MXN' },
] as const

// Document type options
// Map OrderReceiptStatus to Spanish labels
export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  factura: 'Factura',
  prefactura: 'Prefactura',
}

export const ORDER_ORIGIN_LABELS: Record<
  Extract<
    OrderOrigin,
    | 'Tecopos-Marketplace'
    | 'Tecopos-MarketplaceApk'
    | 'External-Thirdparty'
    | 'Tecopos'
    | 'Tecopos-Admin'
    | 'Tecopos-Shop'
    | 'Tecopos-ShopApk'
  >,
  string
> = {
  'Tecopos-Marketplace': 'Sin Terceros',
  'Tecopos-MarketplaceApk': 'APK Sin Terceros',
  'External-Thirdparty': 'Externo',
  Tecopos: 'Punto de venta',
  'Tecopos-Admin': 'Administración',
  'Tecopos-Shop': 'Tienda online',
  'Tecopos-ShopApk': 'APK Tienda',
}
// Generate status options for order status
export const orderStatusOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(ORDER_STATUS_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

// Generate status options for payment status
export const paymentStatusOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(PAYMENT_STATUS_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

// Generate status options for order origin
export const orderOriginOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(ORDER_ORIGIN_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

// Generate status options for document type
export const documentTypeOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(DOCUMENT_TYPE_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

// Type for status option
export interface StatusOption {
  value: string
  label: string
}
